import { DefaultBillTableColumns } from '@enview/interface/types/Bill';
import { SortBy } from '../models/SortOrder';

// uuid v5 namespaces
export const SEARCH_NAMESPACE = 'fd1db410-c8d9-42d6-90c8-3a45f41fd50e';

// password policy
export const PASSWORD_MIN_LENGTH = 12;

// maps tanstack table column ids to sortKeys
export const SORT_BY_FOR_COLUMN: Record<string, SortBy> = {
  'action-date': SortBy.RECENT_ACTIVITY,
  id: SortBy.ALPHANUMERICAL,
  name: SortBy.BILL_TITLE,
  status: SortBy.BILL_STATUS,
  session: SortBy.BILL_SESSION,
  hearings: SortBy.UPCOMING_HEARINGS,
  tags: SortBy.USER_TAGGED,
  democrats: SortBy.DEM_SPONSOR_COUNT,
  republican: SortBy.REP_SPONSOR_COUNT,
};

export const BILL_TABLE_HEADERS: Partial<Record<DefaultBillTableColumns, string>> = {
  [DefaultBillTableColumns.TRACKING]: 'Tracking',
  [DefaultBillTableColumns.TAGS]: 'Tags',
  [DefaultBillTableColumns.POSITION]: 'Position',
  [DefaultBillTableColumns.BILL_ID]: 'Bill ID',
  [DefaultBillTableColumns.BILL_TITLE]: 'Bill Title',
  [DefaultBillTableColumns.BILL_SPONSORS]: 'Bill Sponsors',
  [DefaultBillTableColumns.DEMOCRATS]: '(D)',
  [DefaultBillTableColumns.REPUBLICANS]: '(R)',
  [DefaultBillTableColumns.BILL_STATUS]: 'Bill Status',
  [DefaultBillTableColumns.JURISDICTION]: 'Jurisdiction',
  [DefaultBillTableColumns.SESSION]: 'Session',
  [DefaultBillTableColumns.LATEST_ACTION]: 'Latest Action',
  [DefaultBillTableColumns.ACTION_DATE]: 'Action Date',
  [DefaultBillTableColumns.UPCOMING_HEARING]: 'Upcoming Hearing',
  [DefaultBillTableColumns.LATEST_COMMITTEE_HEARING]: 'Latest Committee Hearing',
  [DefaultBillTableColumns.SOURCE_LINK]: 'Bill ID (Source)',
  [DefaultBillTableColumns.LATEST_KEY_ACTION]: 'Latest Key Action',
  [DefaultBillTableColumns.WORKSPACES]: 'Workspaces',
  [DefaultBillTableColumns.WORKFLOW_STATUS]: 'Workflow Status',
  [DefaultBillTableColumns.ASSIGNEE]: 'Assignee',
  [DefaultBillTableColumns.PRIORITY]: 'Priority',
};

export const WHATS_NEW_DEFAULT_COLUMNS: string[] = [
  DefaultBillTableColumns.BILL_ID,
  DefaultBillTableColumns.BILL_TITLE,
  DefaultBillTableColumns.JURISDICTION,
  DefaultBillTableColumns.WORKFLOW_STATUS,
  DefaultBillTableColumns.WORKSPACES,
  DefaultBillTableColumns.TRACKING,
  DefaultBillTableColumns.NEW_BILL_SOURCE,
  DefaultBillTableColumns.PRIORITY,
  DefaultBillTableColumns.ASSIGNEE,
  DefaultBillTableColumns.ACTION_DATE,
];

// Order roughly follows the All Bills design mockup (Workflow Status, Bill, Title, Tracking,
// then session/status), with the remaining PW-2254 triage columns and Tags appended — All
// Bills has no narrower context of its own the way What's New's sections do, so it keeps a
// couple of columns (Session, Bill Status, Tags) that WHATS_NEW_DEFAULT_COLUMNS omits.
export const ALL_BILLS_DEFAULT_COLUMNS: string[] = [
  DefaultBillTableColumns.WORKFLOW_STATUS,
  DefaultBillTableColumns.BILL_ID,
  DefaultBillTableColumns.BILL_TITLE,
  DefaultBillTableColumns.TRACKING,
  DefaultBillTableColumns.SESSION,
  DefaultBillTableColumns.BILL_STATUS,
  DefaultBillTableColumns.WORKSPACES,
  DefaultBillTableColumns.PRIORITY,
  DefaultBillTableColumns.ASSIGNEE,
  DefaultBillTableColumns.ACTION_DATE,
  DefaultBillTableColumns.TAGS,
];

export const CUSTOM_FIELD_RICH_TEXT_CHAR_LIMIT = 1000;

export const SAVED_SEARCH_RESULTS_LIMIT = 10000;

export const isProd = process.env.REACT_APP_ENV?.toLowerCase() === 'prod';
